// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-audit-comment-container .truncation-button{color:#0e75bb;font-size:16px;font-weight:600;cursor:pointer}.emailReadCounter{font-size:12px;color:dimgray}", ""]);
// Exports
module.exports = exports;
